import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { ButtonModule } from "primeng/button";

import { finalize, Observable, of, tap } from "rxjs";

import {
  AccordionComponent,
  LastUpdatedComponent,
  LoadingComponent,
  SequenceCardComponent,
} from "@shared/components";
import { ParsedSequence } from "@shared/models";
import { MySequencesService } from "@features/home";
import { transformTimestampToLastUpdated } from "@shared/functions";
import { GlobalService } from "@shared/services";

@Component({
  selector: "app-my-sequences",
  standalone: true,
  imports: [
    CommonModule,
    AccordionComponent,
    SequenceCardComponent,
    ButtonModule,
    FormsModule,
    LastUpdatedComponent,
    LoadingComponent,
  ],
  templateUrl: "./my-sequences.component.html",
  styleUrl: "./my-sequences.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MySequencesComponent implements OnInit {
  mySequenceService = inject(MySequencesService);
  globalService = inject(GlobalService);

  monthLabel: string = "";

  sequences$!: Observable<ParsedSequence[]>;
  unfilteredSequences: ParsedSequence[] = [];

  isLoading = signal<boolean>(false);

  ngOnInit(): void {
    this.monthLabel = this.mySequenceService.getMonthLabel(0);
    this.getMonthData(0, false);
  }

  getMonthData(offset: number, force: boolean): void {
    this.isLoading.set(true);
    this.monthLabel = this.mySequenceService.getMonthLabel(offset);
    this.sequences$ = this.mySequenceService
      .getMonthSequences(offset, force)
      .pipe(
        tap((sequences) => {
          this.unfilteredSequences = sequences;
        }),
        finalize(() => {
          this.isLoading.set(false);
        }),
      );
  }

  onFilteredSequences(sequences: ParsedSequence[]): void {
    this.sequences$ = of(sequences);
  }

  getContentHeight(): string {
    const emulatingOffset = this.globalService.emulatedUser() ? 34 : 0;
    const otherContent =
      this.globalService.navbarHeight() + emulatingOffset + 286;
    return `calc(100vh - ${otherContent}px)`;
  }
}
